import {AfterViewInit, Directive, ElementRef} from '@angular/core';

@Directive({
    selector: '[flatpickrPlaceholderSync]'
})
export class FlatpickrPlaceholderSyncDirective implements AfterViewInit {
    constructor(private el: ElementRef<HTMLElement>) {
    }

    ngAfterViewInit() {
        setTimeout(() => {
            const host = this.el.nativeElement;
            const parent = host.parentElement;
            if (!parent) {
                console.warn('No parent element found for placeholder sync');
                return;
            }

            const hiddenInput = host as HTMLInputElement; // o próprio host é o hidden input
            const visibleInput = parent.querySelector('input[type="text"]') as HTMLInputElement | null;

            if (hiddenInput && visibleInput) {
                const placeholder = hiddenInput.getAttribute('placeholder') ?? '';
                visibleInput.setAttribute('placeholder', placeholder);
            } else {
                console.warn('Flatpickr inputs not found for placeholder sync');
            }
        }, 0);
    }
}
